import Dialog from '@jetbrains/ring-ui/components/dialog/dialog'
import {useCallback, memo, useState} from 'react'

import {getHasArtifacts} from '../../../../selectors'
import type {BuildId} from '../../../../types'
import {noop} from '../../../../utils/empty'
import BuildArtifactsTree from '../../BuildArtifactsTree/BuildArtifactsTree'

import ChangesDetailsPopupHeader from './ArtifactChangeDetailsPopupHeader/ArtifactChangeDetailsPopupHeader'

import styles from './ArtifactChangeDetailsPopup.css'

import {useAppSelector} from 'src/hooks/react-redux'

type Props = {
  targetBuildId: BuildId
  buildIds: ReadonlyArray<BuildId>
  show: boolean
  cancelDialog?: (buildId: BuildId) => unknown
}

function ArtifactChangeDetailsPopup({
  targetBuildId,
  buildIds,
  show = false,
  cancelDialog = noop,
}: Props) {
  const [currentBuildId, setCurrentBuildId] = useState(targetBuildId)

  const closeDialog = useCallback(() => {
    cancelDialog(targetBuildId)
  }, [targetBuildId, cancelDialog])

  const hasArtifacts = useAppSelector(state => getHasArtifacts(state, currentBuildId))

  return (
    <div>
      <Dialog
        label="Artifact Dependency Changes"
        className={styles.overlay}
        show={show}
        onCloseAttempt={closeDialog}
        trapFocus
        autoFocusFirst={false}
        showCloseButton
        contentClassName={styles.dialog}
      >
        <div className={styles.wrapper}>
          <ChangesDetailsPopupHeader
            className={styles.header}
            currentBuildId={currentBuildId}
            buildIds={buildIds}
            onChangeCurrentBuildId={setCurrentBuildId}
          />
          {hasArtifacts === true ? (
            <BuildArtifactsTree showToggleHidden={!hasArtifacts} buildId={currentBuildId} />
          ) : (
            <div className={styles.noFiles}>{'No modified files'}</div>
          )}
        </div>
      </Dialog>
    </div>
  )
}

export default memo<Props>(ArtifactChangeDetailsPopup)
